import React from "react";

/**
 * Last-resort catch for render errors: a recovery message instead of a
 * blank page. Router-free on purpose (it wraps the router).
 */
export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="app-error">
        <div className="ui-state ui-state--error" role="alert">
          <p className="ui-state-title">Algo salió mal</p>
          <p>Esta página tuvo un error inesperado. Recarga para intentarlo de nuevo.</p>
          <div className="app-error-actions">
            <button type="button" className="app-error-btn" onClick={() => window.location.reload()}>
              Recargar
            </button>
            <a className="ui-state-link" href="#/">
              Ir al inicio →
            </a>
          </div>
        </div>
      </main>
    );
  }
}
